
<div class="col-6">
    <select class="form-select" [(ngModel)]="SelectedOption" (ngModelChange)="updateFilterSettings()" [compareWith]="compareFilterOptions">
        <option *ngFor="let option of Options" [ngValue]="option">
            {{ option.Name }}
        </option>
    </select>
</div>
<div class="col-6">
    <div class="row">
        <div class="col">
            <input #input1 type="number" class="form-control" [(ngModel)]="Value1" (ngModelChange)="updateFilterSettings()" (keyup.enter)="FirstInputComplete()" />
        </div>
        <ng-container *ngIf="SelectedOption && SelectedOption.Name == 'Is Between'">
            <div class="col-auto align-self-center">and</div>
            <div class="col">
                <input #input2 type="number" class="form-control" [(ngModel)]="Value2" (ngModelChange)="updateFilterSettings()" (keyup.enter)="FilterInputComplete.emit()" />
            </div>
        </ng-container>
    </div>
</div>